import DataTable from "../DataTable/DataTable";
// import ToggleClub from "../ToggleClub/ToggleClub";

import { SessionExtra } from "../../store/Session/SessionModel";
import ModuleKeyData from "../ModuleKeyData/ModuleKeyData";

import "./style.css";

interface Props {
  tabSelected: "ball-data" | "club-data" | "key-data";
  sessionData: SessionExtra;
}

const ClubTables = ({ tabSelected, sessionData }: Props): JSX.Element => {
  return (
    <div className="club-tables">
      {
        sessionData.clubs.map((club, index) => {
          return (
            <div key={index}>
              <div className="table-header">
                <ModuleKeyData
                  club={club}
                  tabSelected={tabSelected}
                />
                {/* <ToggleClub club={club} /> */}
              </div>
              {
                club.isShowShots
                && (
                  <DataTable
                    dataTableType="key-data"
                    tabSelected={tabSelected}
                    club={club}
                  />
                )
              }
            </div>
          );
        })
      }
    </div>
  );
};

export default ClubTables
